import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ApolloProvider } from '@apollo/client';
import { client } from './apollo/ApolloClient'; //? import from  aopllo
import { store } from './app/store';
import { Provider } from 'react-redux';
import { PersistGate } from 'reduxjs-toolkit-persist/integration/react'; //redux
import { persistor } from './app/store'; //redux
import { BrowserRouter } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css'; //? React-Toastify
import { ToastContainer } from 'react-toastify'; //? React-Toastify

const root = createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ApolloProvider client={client}>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <BrowserRouter>
            <App tab='home' />
            <ToastContainer theme='colored' autoClose={3000} hideProgressBar={true} />
          </BrowserRouter>
        </PersistGate>
      </Provider>
    </ApolloProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
